module.exports = __webpack_public_path__ + "static/media/press6.136374db.png";